// extracted by mini-css-extract-plugin
export default {"loaderWrapper":"touch_loader_loaderWrapper__BXJ-V","loader":"touch_loader_loader__2rvvV","shadowPulse":"touch_loader_shadowPulse__WkqKZ"};